export default async (url) => {
    fetch(url)
  
      .then(async (res) => {
        const urlParts = url.split('/');
        const filename = urlParts[urlParts.length - 1] || 'downloaded-file';
  
        return {
          blob: new Blob([await res.blob()]),
          filename,
        };
      })
      .then(({ blob, filename }) => {
        const fileUrl = window.URL.createObjectURL(blob);
        const anchorTag = document.createElement('a');
        anchorTag.href = fileUrl;
        anchorTag.download = filename;
        document.body.appendChild(anchorTag);
        anchorTag.click();
        anchorTag.remove();
      });
  };